import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var WorkingHoursOptions;
(function (WorkingHoursOptions) {
    WorkingHoursOptions[WorkingHoursOptions["InWorkingHours"] = 1] = "InWorkingHours";
    WorkingHoursOptions[WorkingHoursOptions["OutOfWorkingHours"] = 0] = "OutOfWorkingHours";
})(WorkingHoursOptions || (WorkingHoursOptions = {}));
export const WorkingHoursOptionsMap = new Map([
    [WorkingHoursOptions.InWorkingHours, 'Global.Text.InWorkingHours'],
    [WorkingHoursOptions.OutOfWorkingHours, 'Global.Text.OutOfWorkingHours'],
]);
let WorkingHoursService = class WorkingHoursService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = WorkingHoursOptionsMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
WorkingHoursService.ctorParameters = () => [
    { type: TranslateService }
];
WorkingHoursService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], WorkingHoursService);
export { WorkingHoursService };
